import { render, staticRenderFns } from "./DataCell.vue?vue&type=template&id=0d924c93&scoped=true&"
import script from "./DataCell.vue?vue&type=script&lang=ts&"
export * from "./DataCell.vue?vue&type=script&lang=ts&"
import style0 from "./DataCell.vue?vue&type=style&index=0&id=0d924c93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d924c93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VIcon})
